var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-information-card',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Button Preview ")]},proxy:true}])},[_c('app-information-card-item',[_c('app-sso-button',{attrs:{"icon-id":_vm.getValue('buttonImageId'),"button-text":_vm.getValue('buttonText'),"loading":_vm.isLoading}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }